module.exports = __webpack_public_path__ + "static/img/Sección_Eureka_13_pruébala gratis 2.d25bb601.png";